function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 1.000000)",
  stroke: "#391D4D"
}, /*#__PURE__*/React.createElement("g", {
  id: "Buttons-&-Form-elements-/-Checkmark-checked-Copy-2",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.0052166,1 L3.9947834,1 C3.16866809,1 2.41983168,1.33566791 1.87756319,1.87793641 C1.33571081,2.41978879 1,3.16812176 1,3.9947834 L1,14.0052166 C1,14.831128 1.33632271,15.5796981 1.8793998,16.1218047 C2.42270819,16.6641422 3.17309449,17 4.00193497,17 L14.0078793,17 C14.8333942,17 15.5814315,16.6644991 16.1230804,16.1224889 C16.6646553,15.5805528 17,14.832033 17,14.0052166 L17,3.9947834 C17,3.16866809 16.6643321,2.41983168 16.1220636,1.87756319 C15.5802112,1.33571081 14.8318782,1 14.0052166,1 Z",
  id: "Rectangle-277-Copy-6"
}))));

var SvgIconCheckDefault = function SvgIconCheckDefault(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckDefault, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_CheckDefault.1c1d6f79.svg";
export { ForwardRef as ReactComponent };